import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { SbbLoadingIndicator } from "@sbb-esta/lyne-react/loading-indicator";
import { useTranslations } from "providers";

export const AuthLoading = () => {
  const i18n = useTranslations();
  const { inProgress } = useMsal();

  const message = inProgress === InteractionStatus.HandleRedirect ? i18n.Auth_Redirecting : i18n.Auth_Loading;
  return (
    <div className="auth-container">
      <SbbLoadingIndicator size="l" />
      {message}
    </div>
  );
};
